// extracted by mini-css-extract-plugin
export default {"container":"xL-z","topReviewHeading":"yL-z","criticalReview":"zL-z","favorableReview":"AL-z","vsSeparator":"BL-z"};